import { render, staticRenderFns } from "./videoDetail.vue?vue&type=template&id=089a9d8f&scoped=true"
import script from "./videoDetail.vue?vue&type=script&lang=js"
export * from "./videoDetail.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/course/videoDetail.css?vue&type=style&index=0&id=089a9d8f&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089a9d8f",
  null
  
)

export default component.exports